import AddressEditedEvent from './AddressEditedEvent';

const AddressEvents = {
  Edited: AddressEditedEvent,
};

export default AddressEvents;
